export default __webpack_public_path__ + "static/media/logo1.67532c7d.png";